import React from 'react'

const Contact = () => {
  return (
    <div>Contacts</div>
  )
}

export default Contact